module.exports = __webpack_public_path__ + "img/dulijincan.25a55883.png";